import { useUI } from '@components/ui'
import cn from 'clsx'
interface Props {
  classname?: string
  prismicContent?: any
}
const SurfaceDetailsModalButton = ({ classname, prismicContent }: Props) => {
  const { setSidebarView, openSidebar } = useUI()
  const { surfaceSelectionModalButtonText } = prismicContent || undefined
  const showSurfaceDetailsModal = () => {
    setSidebarView('SURFACE_DETAIL_MODAL_VIEW')
    openSidebar()
  }
  return (
    <>
      <div
        className={cn('label-bold flex items-center justify-center', {
          classname,
        })}
        aria-label="Helper Modal"
        onClick={showSurfaceDetailsModal}
      >
        {surfaceSelectionModalButtonText && (
          <>
            <div className="body-2 text-decoration-line: text-brand-dark-grey underline">
              {surfaceSelectionModalButtonText}
            </div>
          </>
        )}
      </div>
    </>
  )
}
export default SurfaceDetailsModalButton
